import { render, staticRenderFns } from "./spaceTreeTransfer.vue?vue&type=template&id=6080c88c&scoped=true"
import script from "./spaceTreeTransfer.vue?vue&type=script&lang=js"
export * from "./spaceTreeTransfer.vue?vue&type=script&lang=js"
import style0 from "./spaceTreeTransfer.vue?vue&type=style&index=0&id=6080c88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080c88c",
  null
  
)

export default component.exports